import * as React from 'react'
import { Link } from 'react-router-dom'
import { usePermissions } from '../../../hooks/usePermissions'

interface Props {
  text: string
  strategyId: number
}

const UNTITLED_STRATEGY_NAME = 'Untitled strategy'

export const ListingStrategyLink: React.FC<Props> = props => {
  const content = props.text || UNTITLED_STRATEGY_NAME
  const { permissions } = usePermissions()
  return props.strategyId && permissions.includes('settings.strategies') ? (
    <Link to={`/admin/listing_strategies/${props.strategyId}/edit`}>{content}</Link>
  ) : (
    <>&lsquo;{content}&rsquo;</>
  )
}
